import { forwardRef } from "react";

interface BotSweepLogoProps {
  size?: number;
  className?: string;
}

const BotSweepLogo = forwardRef<SVGSVGElement, BotSweepLogoProps>(
  ({ size = 24, className = "" }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M32 4L8 16V34C8 48 18 58 32 62C46 58 56 48 56 34V16L32 4Z"
          stroke="hsl(var(--primary))"
          strokeWidth="2.5"
          fill="none"
          opacity="0.9"
        />
        <path
          d="M32 12L14 21V34C14 45 22 53 32 56C42 53 50 45 50 34V21L32 12Z"
          stroke="hsl(var(--primary))"
          strokeWidth="1"
          fill="none"
          opacity="0.3"
        />
        <line
          x1="32" y1="32" x2="48" y2="18"
          stroke="hsl(var(--primary))"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="1"
        />
        <path
          d="M32 32 L48 18 A22 22 0 0 1 50 28 Z"
          fill="hsl(var(--primary))"
          opacity="0.15"
        />
        <circle cx="32" cy="32" r="3" fill="hsl(var(--primary))" opacity="0.9" />
        <circle cx="32" cy="32" r="8" stroke="hsl(var(--primary))" strokeWidth="0.8" fill="none" opacity="0.2" />
        <circle cx="32" cy="32" r="14" stroke="hsl(var(--primary))" strokeWidth="0.6" fill="none" opacity="0.12" />
      </svg>
    );
  }
);

BotSweepLogo.displayName = "BotSweepLogo";

export default BotSweepLogo;
